import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_KEY = 'hamac_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const accept = (mode) => {
    const value = { essential: true, analytics: mode === 'all', accepted_at: new Date().toISOString(), mode };
    localStorage.setItem(COOKIE_KEY, JSON.stringify(value));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-zinc-900 text-white border-t border-zinc-700 shadow-2xl" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto px-4 py-4 sm:py-5">
        {!showCustomize ? (
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1 text-sm leading-relaxed">
              <p>
                Ce site utilise des cookies essentiels au fonctionnement. En savoir plus dans notre{' '}
                <Link to="/confidentialite" className="underline font-semibold text-white">politique de confidentialité</Link>.
              </p>
            </div>
            <div className="flex gap-2 shrink-0">
              <button onClick={() => accept('refuse')} className="px-4 py-2 text-sm font-medium border border-zinc-600 rounded-sm hover:bg-zinc-800 transition-colors" data-testid="cookie-refuse-btn">
                Refuser
              </button>
              <button onClick={() => setShowCustomize(true)} className="px-4 py-2 text-sm font-medium border border-zinc-600 rounded-sm hover:bg-zinc-800 transition-colors" data-testid="cookie-customize-btn">
                Personnaliser
              </button>
              <button onClick={() => accept('all')} className="px-4 py-2 text-sm font-bold bg-white text-zinc-900 rounded-sm hover:bg-zinc-100 transition-colors" data-testid="cookie-accept-btn">
                Accepter
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-sm font-semibold">Personnaliser les cookies</p>
            <div className="space-y-3">
              <label className="flex items-center gap-3">
                <input type="checkbox" checked disabled className="accent-white" />
                <span className="text-sm"><strong>Essentiels</strong> — nécessaires au fonctionnement (toujours actifs)</span>
              </label>
              <label className="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" checked={analytics} onChange={e => setAnalytics(e.target.checked)} className="accent-white" />
                <span className="text-sm"><strong>Analytiques</strong> — amélioration de l'expérience</span>
              </label>
            </div>
            <div className="flex gap-2">
              <button onClick={() => setShowCustomize(false)} className="px-4 py-2 text-sm border border-zinc-600 rounded-sm hover:bg-zinc-800">Retour</button>
              <button onClick={() => accept(analytics ? 'all' : 'essential_only')} className="px-4 py-2 text-sm font-bold bg-white text-zinc-900 rounded-sm hover:bg-zinc-100" data-testid="cookie-save-btn">
                Enregistrer mes préférences
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
